import React from 'react';
import './Banner.css';
import productImage1 from './product1.png';
import productImage2 from './product2.png';
import productImage4 from './product4.png';

const Banner: React.FC = () => {
  return (
    <section className="banner">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-6">
            <h1>Flashcard World Program</h1>
            <p className="banner-subtitle">The Ultimate Educational Tool for Early Childhood Development</p>
            <p className="banner-description">
              Specifically designed for interactive early learning, providing a rich environment for children 
              to discover new words through beautiful visuals and high-quality audio.
            </p>
            <ul className="features-list">
              <li>
                <span className="feature-icon">🌟</span>
                <div>
                  <strong>Diverse Learning Topics</strong>
                  <p>Explore animals, fruits, vehicles, and more.</p>
                </div>
              </li>
              <li>
                <span className="feature-icon">🔊</span>
                <div>
                  <strong>Bilingual Audio</strong>
                  <p>Native pronunciations in English and Vietnamese.</p>
                </div>
              </li>
              <li>
                <span className="feature-icon">✨</span>
                <div>
                  <strong>Interactive Fun</strong>
                  <p>Animated interface to keep kids engaged and happy.</p>
                </div>
              </li>
            </ul>
          </div>
          <div className="col-md-6">
            <div className="row">
              <div className="col-12 mb-4">
                <img src={productImage1} alt="Product 1" className="img-fluid rounded shadow-lg" />
              </div>
              <div className="col-12">
                <img src={productImage2} alt="Product 2" className="img-fluid rounded shadow-lg" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
